import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 1.5rem;
`;

export const Description = styled.span`
  font-size: 1.2em;
  font-weight: 600;
`;

export const Tap = styled.span`
  display: flex;
  align-items: center;
  gap: 0.3rem;
  font-size: 1.1em;
`;
